; (function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('TopDrawer', [], factory);
    } else {
        // Browser globals
        root.TopDrawer = factory();
    }
}(typeof self !== 'undefined' ? self : this, function () {
        'use strict';

        var DEFAULTS = {

        }

        function TopDrawer(element, options) {
            this.container = element;
            this.content = element.children;

            this.close = this.close.bind(this);
            this.open = this.open.bind(this);
            this.toggle = this.toggle.bind(this);

            this.container.addEventListener('click', this.toggle);
            this.container.addEventListener('mouseleave', this.close);

            for (var i = 0; i < this.content.length; i++) {
                this.content[i].addEventListener('click', function (event) {
                    event.stopPropagation();
                });
            }
        }

        TopDrawer.prototype = {
            close: function () {
                this.container.classList.remove('-open');
            },
            open: function () {
                this.container.classList.add('-open');
            },
            toggle: function () {
                if (this.container.classList.contains('-open')) {
                    this.close();
                } else {
                    this.open();
                }
            }
        }

        return TopDrawer;

}));